/**
 * @description: merchantIDWhiteList 支持申请on time Delivery Guarantee 白名单 https://seel.atlassian.net/browse/OP-3530
 * source https://www.notion.so/wassupkover/shopify-gdd-e366cb279afc4823b1dd1d41af06753b
 * @summary  thread: https://seelplatform.slack.com/archives/C0702U590Q4/p1715585639681709
 */
export const merchantIDWhiteList = [
  '1657101100205890',
  '2024031820209350224350',
  '2023022120793376816447',
  'M514824891426',
  'M225022826081',
  'M396672195547',
  'M573368724742',
  'M747238147245',
  'M899768416932',
  '2024030120749334354607',
  'M925325336851',
  'M737245723938',
  'M940455897406',
  'M284059833595',
  'M551830989388',
  'M851890931852',
  'M757479313831',
  'M750184179381',
  '2023091520688755454467',
  'M524867921068',
  'M845751743716',
  '2024012820629667359912',
  'M346547075025',
  'M854719452831',
  'M137291790146',
  '2023091420016583407178',
  '2024020120648640351390',
  'M582632032715',
  'M542764289479',
  '2023111620814385582142',
  'M507748287151',
  'M860280608325',
  'M253483229658',
  'M619516173892',
  'M689907072504',
  'M192428893821',
  'M560448684529',
  '2023022820805648343138',
  '2023080920702145343005',
  'M566101181960',
  'M830548458507',
  '2024012320661832388701',
  'M043650445883',
  'M366369451038',
  '2022120420807709259982',
  'M265605455168',
  '2023092820637391214366',
  'M939561057646',
  '2023112920818837486000',
  '111111',
  '2024042520269933640956', // for test rita-wu.myshopify.com
  'M010987231538', // prod test 店铺 seel-demo-store.myshopify.com
];
